var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyappblue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 4.5H5.25C4.83579 4.5 4.5 4.83579 4.5 5.25V9.75C4.5 10.1642 4.83579 10.5 5.25 10.5H9.75C10.1642 10.5 10.5 10.1642 10.5 9.75V5.25C10.5 4.83579 10.1642 4.5 9.75 4.5Z",
    stroke: "#838FB4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 4.5H14.25C13.8358 4.5 13.5 4.83579 13.5 5.25V9.75C13.5 10.1642 13.8358 10.5 14.25 10.5H18.75C19.1642 10.5 19.5 10.1642 19.5 9.75V5.25C19.5 4.83579 19.1642 4.5 18.75 4.5Z",
    stroke: "#838FB4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 14H5.25C4.83579 14 4.5 14.3358 4.5 14.75V19.25C4.5 19.6642 4.83579 20 5.25 20H9.75C10.1642 20 10.5 19.6642 10.5 19.25V14.75C10.5 14.3358 10.1642 14 9.75 14Z",
    stroke: "#0066CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.959 20.84C20.932 20.8887 20.8931 20.9291 20.8463 20.9572C20.7995 20.9852 20.7464 21 20.6924 21H13.3074C13.2534 20.9999 13.2004 20.9851 13.1536 20.957C13.1069 20.9289 13.0681 20.8885 13.0411 20.8399C13.0142 20.7912 13 20.7361 13 20.68C13 20.6238 13.0142 20.5687 13.0412 20.5201C13.627 19.467 14.5298 18.7119 15.5833 18.354C15.0622 18.0314 14.6573 17.5399 14.4308 16.9549C14.2044 16.3699 14.1689 15.7238 14.3297 15.1157C14.4906 14.5077 14.839 13.9714 15.3214 13.5892C15.8037 13.207 16.3934 13 16.9999 13C17.6064 13 18.1961 13.207 18.6784 13.5892C19.1608 13.9714 19.5092 14.5077 19.6701 15.1157C19.8309 15.7238 19.7954 16.3699 19.569 16.9549C19.3425 17.5399 18.9376 18.0314 18.4165 18.354C19.47 18.7119 20.3728 19.467 20.9586 20.5201C20.9856 20.5687 20.9999 20.6238 21 20.68C21.0001 20.7362 20.9859 20.7913 20.959 20.84Z",
    fill: "#0066CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyappblue);
export default __webpack_public_path__ + "static/media/myappblue.8d8f8ce9e30a8cdc9c08e3897a19fed5.svg";
export { ForwardRef as ReactComponent };